import { Button } from '../../../atoms/Button';
import { useState } from 'react';
import { ContentReportModal } from '../ContentReportModal';

interface IContentReportProps {
  className?: string;
}

export function ContentReport({ className }: IContentReportProps) {
  const [isReportModalOpen, setIsReportModalOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        variant='text'
        size='large'
        onlyIcon
        LeftIcon={'report_gmailerrorred'}
        iconType='material'
        classNameIcon={className}
        onClick={() => {
          setIsReportModalOpen(true);
        }}
        className={'p-0'}
      />

      <ContentReportModal
        isOpen={isReportModalOpen}
        onClose={() => {
          setIsReportModalOpen(false);
        }}
      />
    </>
  );
}
